import { Button, IconCalendar16, Tooltip } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './FlatViewButtonCollapsed.css';
import { TFlatViewButtonComponent } from '../../types';

export const FlatViewButtonCollapsed: TFlatViewButtonComponent = ({ onClick, disabled }) => {
  return (
    <Tooltip title="Записаться на просмотр">
      <div className={cx(styles['button'], disabled && styles['button__disabled'])}>
        <Button
          onClick={onClick}
          disabled={disabled}
          beforeIcon={<IconCalendar16 color="current_color" />}
          theme="fill_secondary"
          size="M"
        />
      </div>
    </Tooltip>
  );
};
